<template>
  <div>
    <b-form @submit.prevent="save">
      <b-row>
        <b-col md="6">
          <b-form-group :label="$t('NAME')">
            <b-form-input v-model="institutionData.name" type="text"></b-form-input>
            <app-validation-description :show="$v.institutionData.name.$dirty && $v.institutionData.name.$invalid">
              {{$t('FIELD_MANDATORY')}}
            </app-validation-description>
          </b-form-group>
        </b-col>
        <b-col md="6">
        <b-form-group :label="$t('ECONOMY')">
          <b-form-select v-model="economy.id" >
            <option :value="null">-</option>
            <option :key="index" v-for="(economy, index) in economics" :value="economy.id">
              {{economy.name}}
            </option>
          </b-form-select>
          <app-validation-description :show="$v.economy.id.$dirty && $v.economy.id.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </app-validation-description>
        </b-form-group>
      </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col>
          <app-button-submit :loading="loading_save" :c_permission="C_INSTITUTION_SAVE_BUTTON"></app-button-submit>
        </b-col>
        <b-col sm="6" md="6" lg="6">
          <delete-button :c_permission="C_INSTITUTION_DELETE_BUTTON"
                         v-if="institutionData.id"
                         @click="showDeleteDialog=true"
                         class="pull-right">
          </delete-button>
        </b-col>
      </b-row>
    </b-form>
    <delete-dialog :show="showDeleteDialog"
                    @confirm="deleteInst"
                    @cancel="showDeleteDialog=false">
    </delete-dialog>
  </div>
</template>

<script>
import AppButtonSubmit from '@/components/app/AppSubmit'
import {getErrorMessage} from '@/mixins/error/getErrorMessage'
import {toast} from "@/shared/plugins/toastr"
import {createInstitution, updateInstitution, deleteInstitution} from "@/services/institution"
import {getEconomyList} from "@/services/economy"
import DeleteDialog from '@/components/app/form/AppConfirmationDialog'
import DeleteButton from '@/components/app/AppDelete'
import {C_INSTITUTION_SAVE_BUTTON} from '@/shared/component_permission'
import {C_INSTITUTION_DELETE_BUTTON} from '@/shared/component_permission'
import {required} from "vuelidate/lib/validators";
import AppValidationDescription from "@/components/app/form/AppValidationDescription";

export default {
    name: "institution-edit-form",
    props:{
      itemEdit:{

      },
      items: {
        type:Array,
      }
    },
    data() {
        return {
            institutionData: {
              id:null,
              name:null,
            },
            economy:{
              id:null,
              name:null
            },
            economics:[],
            instEditAsidePanelState:'',
            showDeleteDialog:false,
            C_INSTITUTION_SAVE_BUTTON,
            C_INSTITUTION_DELETE_BUTTON,
            loading_save:false
        }
    },
    instEditAsidePanelState:false,
    validations: {
      institutionData:{
        name:{required},
      },
      economy:{
        id:{required}
      }


    },
    components: {
      AppValidationDescription,
      AppButtonSubmit,
      DeleteDialog,
      DeleteButton
    },
    methods: {
        save() {

          this.$v.$touch()
          if (this.$v.$invalid) {
            toast({
              'title': this.$t('VALIDATION_FAILED'),
              'message': null,
              'type': 'error',
              'timeout': 6000
            })
            return
          }
          let postData = {
            economy: this.economy.id,
            name:this.institutionData.name

          }
          if(!this.institutionData.id){
            this.create(postData)
          } else {
            this.update(postData)
          }
        },
        getEconomies() {
          getEconomyList()
             .then(response => {
               this.economics = response.data
            })
        },
        create(postData) {
          this.loading_save = true
          createInstitution(postData)
            .then(()=>{
              toast({
              'title': this.$t('NOTIFICATIONS.SAVE_SUCCESS.TITLE'),
              'message': this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
              'type': 'success',
              'timeout': 2000,
            })
              this.$emit('closePanel', this.instEditAsidePanelState)
              this.$emit('updated', this.instEditAsidePanelState)
          },error=>{
            toast({
              title: this.$t('NOTIFICATIONS.SAVE_ERROR.TITLE'),
              message: this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE', {value: this.getMessages(error)}),
              'type': 'error',
              'timeout': 6000
            })
          }).finally(()=>{
            this.loading_save = false
          })
        },
      update(postData){
        this.loading_save = true
        updateInstitution(this.institutionData.id,postData)
          .then(()=>{
            toast({
                'title': this.$t('NOTIFICATIONS.SAVE_SUCCESS.TITLE'),
                'message': this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
                'type': 'success',
                'timeout': 2000,
              })
              this.$emit('closePanel', this.instEditAsidePanelState)
              this.$emit('updated', this.instEditAsidePanelState)
          },error=>{
            toast({
              title: this.$t('NOTIFICATIONS.SAVE_ERROR.TITLE'),
              message: this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE', {value: this.getMessages(error)}),
              'type': 'error',
              'timeout': 6000
            })
          }).finally(()=>{
          this.loading_save = false
        })
      },
      deleteInst(){
        deleteInstitution(this.institutionData.id)
          .then(()=>{
            this.showDeleteDialog = false,
            toast({
              'title': this.$t('NOTIFICATIONS.DELETE_SUCCESS.MESSAGE'),
              'message': null,
              'type': 'success',
              'timeout': 2000,
            })
             setTimeout(() => {
               this.$emit('closePanel', this.instEditAsidePanelState)
               this.$emit('updated', this.instEditAsidePanelState)
            }, 500)
          },error=>{
            toast({
              'title': "Save  fail",
              'message': this.getMessages(error),
              'type': 'error',
              'timeout': 6000
            })
          })
      }
    },
    created(){
      if(this.itemEdit){
        this.institutionData.id = this.itemEdit.id
        this.institutionData.name = this.itemEdit.name
        this.economy.id = this.itemEdit.economy.id
      }
      this.getEconomies()
  }
}
</script>
